// general messages
export const MESSAGE_NON_RESIDENTIAL_ADDRESS = `This must be the applicant's residence, not a P.O. Box, business or mail drop address.`;
// error messages
export const ERROR_ADDRESS_PATTERN = 'Enter a valid address.';
export const ERROR_ADDRESS_REQUIRED = 'Please enter an address.';
export const ERROR_PO_BOX_PATTERN = `This address can't be a P.O. Box.`;
export const COMMON_PASSWORDS_BLACKLIST = [
    'letmein',
    'qwerty',
    'asdfghjkl',
    'default',
    'iloveyou',
    'password',
    'p@ssword',
    'passw0rd',
    'p@ssw0rd',
    'pa$$w0rd',
    'p@$$w0rd',
];
export var PasswordStrength;
(function (PasswordStrength) {
    PasswordStrength["None"] = "";
    PasswordStrength["Fair"] = "Fair";
    PasswordStrength["Medium"] = "Medium";
    PasswordStrength["Strong"] = "Strong";
})(PasswordStrength || (PasswordStrength = {}));
//# sourceMappingURL=constants.js.map